import { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import PageTitle from '@components/PageTitle'
import Layout from '@layout/Main'
import TableBilling from './TableBilling'

function AffiliateComission() {
  return (
    <Fragment>
      <Helmet>
        <title>
          SQUIDS :: Setup Komisi Affiliate
        </title>
      </Helmet>
      <PageTitle>
        Setup Komisi Affiliate
      </PageTitle>
      <Layout>
        <TableBilling />
      </Layout>
    </Fragment>
  )
}

export default AffiliateComission
